export default {
  user: {
    myRequests: "My Requests",
    myApprovals: "My Approvals"
  },
  admin: {
    totalUsers: "Total Users",
    pendingMod: "Pending Modifications"
  }
}